// Filename - pages/about.js

import React from "react";
import MyHeader from "../components/headerComponent.js";
import Navbar from "../components/nav.js";
import About from "../components/aboutComponent.js";
import SocialsBar from "../components/socialsBar.js";
import MyFooter from "../components/footerComponent.js";

const AboutUs = () => {
	return (
		<div className="About-Us">
            <header>
                <MyHeader />
                <Navbar />
            </header>
            <main>
                <h2> About </h2>
                <About />
            </main>
            <footer>
                <SocialsBar />
                <MyFooter />
            </footer>
		</div>
	);
};

export default AboutUs;